import { OrphanRetailer } from '__generated__/atlas-types'

export interface CustomerSelectionState {
  isAddingNewCustomer: boolean
  selectedRetailerId: string | null | undefined
  selectedOrphanRetailerId: string | null | undefined
  orphanRetailer?: OrphanRetailer | null
  checkForEmail?: boolean
}

/**
 * Returns true when a new (orphan) customer entry has a validated email that
 * matches what the user currently has typed. The email is only written to
 * orphanRetailer once it passes regex validation, so equality is enough to
 * confirm the field is in a valid, committed state.
 */
export const isValidOrphanCustomer = (
  orphanRetailer: OrphanRetailer | null | undefined,
  checkForEmail: boolean = false,
): boolean =>
  checkForEmail
    ? Boolean(orphanRetailer?.retailerEmail) &&
      Boolean(orphanRetailer?.retailerName)
    : Boolean(orphanRetailer?.retailerName)

/**
 * Returns true when the user has made a valid customer selection, regardless
 * of whether it is an existing retailer or a new (orphan) customer.
 */
export const hasValidCustomerSelection = ({
  isAddingNewCustomer,
  selectedRetailerId,
  selectedOrphanRetailerId,
  orphanRetailer,
  checkForEmail = false,
}: CustomerSelectionState): boolean =>
  isAddingNewCustomer
    ? isValidOrphanCustomer(orphanRetailer, checkForEmail)
    : Boolean(selectedRetailerId || selectedOrphanRetailerId)

export const formatOrphanRetailerDisplay = (orphanRetailer: OrphanRetailer) => {
  const { retailerName, retailerEmail } = orphanRetailer

  return `${retailerName} (${retailerEmail})`
}
